import { render, staticRenderFns } from "./AchievementCard.vue?vue&type=template&id=85bbe0de&"
import script from "./AchievementCard.vue?vue&type=script&lang=js&"
export * from "./AchievementCard.vue?vue&type=script&lang=js&"
import style0 from "./AchievementCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports